import { render } from "./p2Page.vue?vue&type=template&id=31f9d434&scoped=true"
import script from "./p2Page.vue?vue&type=script&lang=js"
export * from "./p2Page.vue?vue&type=script&lang=js"

import "./p2Page.vue?vue&type=style&index=0&id=31f9d434&scoped=true&lang=css"

import exportComponent from "/Users/song/Desktop/pro/homePage/沙漠传说/desertlegendhomepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f9d434"]])

export default __exports__